// Unpublished Work © 2021-2025 Deere & Company.

import React from 'react';
import PropTypes from 'prop-types';
import {PageStatus} from '../../../state/struct/page-status';
import {FullScreenCircularProgress} from '@deere/cap-it-ui.component-library';
import {PageError} from '../page-error/page-error';

export const LoadingContainer = (props) => {
    const renderItems = {
        [PageStatus.meta.map.LOADING]: <FullScreenCircularProgress loading={true}/>,
        [PageStatus.meta.map.ERROR]: <PageError message={props.message}/>,
        [PageStatus.meta.map.COMPLETE]: props.children
    };

    return renderItems[props.loadingStatus];
};

LoadingContainer.propTypes = {
    children: PropTypes.node.isRequired,
    loadingStatus: PropTypes.oneOf(Object.values(PageStatus.meta.map)).isRequired,
    message: PropTypes.string
};
